module.exports = __webpack_public_path__ + "static/media/musical-spectrum.ec803395.gif";